module.exports = __webpack_public_path__ + "img/demo5.4240ce5a.png";